import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '@shared/services';

import { endsWith, forEach } from 'lodash';

import { HttpError, ValidationError } from '@shared/models';
import { environment } from '@env';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError((err, caught) => {
            if (!environment.production) {
                console.log(err);
            }

            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logoutFromStorage(true);
            }

            if (err.status == 422) {
                const error: ValidationError = new ValidationError(err.error);
                return throwError(error);
            }
            
            // const error = err.error.message || err.statusText;
            if (!environment.production || err.status != 500) {
                return throwError(new HttpError(err));
            }

            return throwError(err);
        }))
    }

    /* private nonRedirectStrings: string[] = [
        'api/auth/user'
    ];

    private redirectOnFailUrlCheck(request: HttpRequest<any>): boolean {
        let redirect = true;
        forEach(this.nonRedirectStrings, (url) => {
            if (endsWith(request.url, url)) {
                redirect = false;
                return false;
            }
        });

        return redirect;
    } */
}